import { ListItemIcon, MenuItem, Paper } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import {
  AccountBalance,
  Android,
  Apps,
  Assessment,
  Assignment,
  AttachMoney,
  BubbleChart,
  ChevronLeft,
  ChevronRight,
  Close,
  Compare,
  Dashboard,
  DynamicFeedRounded,
  Email,
  Group,
  Home,
  List,
  Menu,
  Person,
  Public,
  SupervisorAccount,
  Work,
} from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MenuCategory } from "../../Enums/MenuCategory";
import ProfileComponent from "../ProfileComponent/ProfileComponent";
import NavBarItem from "./NavBarItem";
import SubMenu from "./SubMenu/SubMenu";
import SubMenuItem from "./SubMenu/SubMenuItem";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    "& .MuiList-root": {
      overflowY: "auto",
      overflowX: "visible",
    },
  },
  paper: {
    background: theme.palette.primary.main,
    overflowX: "hidden",
    zIndex: 10,
    height: "100vh",
    alignItems: "center",
    boxShadow: "0px 0px 5px darkgrey",
    display: "block",
    flexDirection: "row",
  },
  paperHidden: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    background: theme.palette.primary.main,
    overflowX: "hidden",
    zIndex: 10,
    height: "100vh",
    alignItems: "center",
    boxShadow: "0px 0px 5px darkgrey",
    display: "block",
  },
  exitButton: {
    [theme.breakpoints.down("sm")]: {
      display: "block",
      padding: "20px",
      justifyContent: "center",
    },
    display: "none",
  },
  bottomButtons: {
    position: "absolute",
    bottom: "0px",
  },
  navBarArrow: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    position: "absolute",
    top: "50vh",
    zIndex: 20,
    left: "75px",
  },
  subMenuArrow: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    position: "absolute",
    top: "50vh",
    right: "-20px",
  },
  arrowButton: {
    "&:hover": {
      backgroundColor: "white",
      color: theme.palette.primary.main,
    },
    transition: "0.5s",
    height: "40px",
    width: "40px",
    background: "white",
    boxShadow: "0px 0px 5px darkgrey",
  },
  navHamburger: {
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      left: "20px",
      top: "20px",
      zIndex: 10,
      display: "block",
    },
    display: "none",
  },
  itemIcon: {
    color: "white",
    justifyContent: "center",
  },
}));

export default function NavBar() {
  const classes = useStyles();

  const [navBarVisible, setNavBarVisible] = useState(true);
  const [selected, setSelected] = useState(0);
  const [subMenuOpen, setSubMenuOpen] = useState(false);

  const currentRoute = useLocation().pathname;

  function updateSelectedNoSubMenu(index: number) {
    if (index !== selected) {
      setSubMenuOpen(false);
      setSelected(index);
    }
  }

  function openSubMenu(index: number) {
    setSelected(index);
    if (index === selected || !subMenuOpen) {
      setSubMenuOpen(!subMenuOpen);
    }
  }

  function toggleNavBar() {
    setNavBarVisible(!navBarVisible);
    if (navBarVisible && subMenuOpen) {
      setSubMenuOpen(false);
    }
  }

  useEffect(() => {
    if (currentRoute === "/profile") {
      setSelected(MenuCategory.AccountSettings);
    } else if (currentRoute !== "/") {
      setSelected(MenuCategory.Administration);
    }
  }, [currentRoute]);

  return (
    <>
      <ProfileComponent />
      <div className={classes.root}>
        <Paper square className={navBarVisible ? classes.paper : classes.paperHidden}>
          {navBarVisible ? (
            <div>
              <MenuItem className={classes.exitButton} onClick={() => toggleNavBar()}>
                <ListItemIcon className={classes.itemIcon}>
                  <Close />
                </ListItemIcon>
              </MenuItem>
              <Divider />
            </div>
          ) : null}
          <NavBarItem
            icon={<Home />}
            clickEvent={() => updateSelectedNoSubMenu(0)}
            menuIndex={0}
            currentMenuSelection={selected}
            tooltipText={"Home"}
            route={"/baseclientmanagement"}
          />
          <NavBarItem
            icon={<Assignment />}
            clickEvent={() => openSubMenu(MenuCategory.Administration)}
            menuIndex={MenuCategory.Administration}
            currentMenuSelection={selected}
            tooltipText={"Administration"}
            route={null}
          />
          <Divider />
          <div className={classes.bottomButtons}>
            <NavBarItem
              icon={<Apps />}
              clickEvent={() => openSubMenu(MenuCategory.MoreApps)}
              menuIndex={MenuCategory.MoreApps}
              currentMenuSelection={selected}
              tooltipText={"More Apps"}
              route={null}
            />
            <NavBarItem
              icon={<Person />}
              clickEvent={() => updateSelectedNoSubMenu(MenuCategory.AccountSettings)}
              menuIndex={MenuCategory.AccountSettings}
              currentMenuSelection={selected}
              tooltipText={"Profile"}
              route={"/profile"}
            />
          </div>
        </Paper>

        <SubMenu open={subMenuOpen} index={selected}>
          <SubMenuItem
            icon={<Assignment />}
            title={"Client Management"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/baseclientmanagement"}
          />
          <SubMenuItem
            icon={<Work />}
            title={"Careers Management"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/careersclientmanagement"}
          />
          <SubMenuItem
            icon={<Group />}
            title={"User Management"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/usermanagement"}
          />
          <SubMenuItem
            icon={<AccountBalance />}
            title={"Billing Reports"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/billingreports"}
          />
          <SubMenuItem
            icon={<SupervisorAccount />}
            title={"Here.com Accounts"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/heredotcom"}
          />
          <SubMenuItem
            icon={<AttachMoney />}
            title={"Billing Tiers"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/billingtiers"}
          />
          <SubMenuItem
            icon={<DynamicFeedRounded />}
            title={"Inbound Feeds"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/inboundfeeds"}
          />
          <SubMenuItem
            icon={<Android />}
            title={"Google Accounts"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/googleaccounts"}
          />
          <SubMenuItem
            icon={<Email />}
            title={"Email Templates"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/emailtemplates"}
          />
          <SubMenuItem
            icon={<Public />}
            title={"Outbound Feeds"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/outboundfeeds"}
          />
          <SubMenuItem
            icon={<Assessment />}
            title="Features Enabled"
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/featuresenabled"}
          />
          <SubMenuItem
            icon={<Compare />}
            title="A/B Testing"
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/abtesting"}
          />
          <SubMenuItem
            icon={<List />}
            title="Job Board Scrapes"
            navMenuSelection={selected}
            menuCategory={MenuCategory.Administration}
            route={"/jobboardscrapes"}
          />
          <SubMenuItem
            icon={<Dashboard />}
            title={"Activate Management"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.MoreApps}
            route={import.meta.env.VITE_ACTIVATE_PORTAL}
          />
          <SubMenuItem
            icon={<BubbleChart />}
            title={"Talentegy Analytics"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.MoreApps}
            route={import.meta.env.VITE_TALENTEGY}
          />
          {/* TODO - The support portal is inactive. It's temporarily removed until a better solution is determined. */}
          {/* <SubMenuItem
            icon={<Help />}
            title={"Support Portal"}
            navMenuSelection={selected}
            menuCategory={MenuCategory.MoreApps}
            route={import.meta.env.VITE_SUPPORT_PORTAL}
          /> */}
        </SubMenu>

        <div className={classes.navBarArrow}>
          {selected !== 0 && selected !== MenuCategory.AccountSettings ? (
            <IconButton className={classes.arrowButton} onClick={() => openSubMenu(selected)}>
              {!subMenuOpen ? <ChevronRight /> : <ChevronLeft />}
            </IconButton>
          ) : null}
        </div>
        {navBarVisible ? null : (
          <div className={classes.navHamburger}>
            <IconButton className={classes.arrowButton} onClick={() => toggleNavBar()}>
              <Menu />
            </IconButton>
          </div>
        )}
      </div>
    </>
  );
}
